import PropTypes from 'prop-types';

export const ClientPropTypes = PropTypes.shape({
  clientId: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  shortName: PropTypes.string.isRequired,
  icon: PropTypes.string,
});

export const FeatureFlagPropTypes = PropTypes.shape({
  field: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired,
});

export const FeatureFlagsPropTypes = PropTypes.objectOf(FeatureFlagPropTypes);

export const ClientListPropTypes = PropTypes.arrayOf(ClientPropTypes);
